// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"1012f984","453":"99e2b55a","479":"a65e48a5","835":"931a2ac6","908":"aa560a21"}[chunkId] + ".chunk.js";
};